import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { generateCorrelationId } from 'helpers/generateCorrelationId';
import host from './apiConfig';

export const rootApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: host,
    timeout: 3000,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().session?.sessionToken;
      // Only set global token header if not provided by the endpoint
      if (!headers.get('token') && token) {
        headers.set('token', token);
      }
      if (!headers.get('X-Correlation-ID')) {
        headers.append('X-Correlation-ID', generateCorrelationId());
      }
      return headers;
    },
  }),
  refetchOnMountOrArgChange: true,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  endpoints: () => ({}),
});
